import {
  rewindHsaGroupInput,
  rewindHsaGroupOutput,
} from "@redotech/redo-conversion-hsa-common/rpc-schemas/rewind-hsa-group";
import { unaryRpc } from "@redotech/rpc/definition";

// Step-through Back: returns the step before the client's current one on the
// active path (read-only — nothing about the session changes).
export const rewindHsaGroup = unaryRpc({
  name: "rewindHsaGroup",
  input: rewindHsaGroupInput,
  output: rewindHsaGroupOutput,
});
